module.exports = __webpack_public_path__ + "static/image2-6bf5324396cd12af7e81b5b2c34c5657.png";